import  { useState } from 'react'
import Slides from '../slides/Slides'
import Card from './Card'
import Casemi from './Casemi'
import DividingBar from './DividingBar'
import MinDesEcoPro from './MinDesEcoPro'
import Blog from './Blog'
import Capacitacion from './Capacitacion'
import BancoMacro from './BancoMacro'
import Srt from './Srt'
import MsjHome from './MsjHome'
import Clientes from './Clientes'
import Contactanos from './Contactanos'
import Instagram from './Instagram'
import LinkedIn from './LinkedIn'
import FaceBook from './FaceBook'


const Home = ({M}) => {
   const [modalHome,setModalHome]          = useState('modal-show');
   const [modalClientes, setModalClientes] = useState('');
   window.addEventListener("click", function (e) {
      setModalHome('');
   });
   
   return (
      <> 
         <Slides M={M} tipoSlides={"home"} setModalClientes={setModalClientes}/>
         <Card/>
         <Casemi M={M}/>
         <DividingBar/>
         <MinDesEcoPro/>
         <Blog/>
         <Capacitacion/>
         <DividingBar/>
         <BancoMacro/>
         <DividingBar/>
         <Srt/>
         <DividingBar/>
         <MsjHome/>
         <Clientes/>
         <Contactanos/>
         <DividingBar/>
         <FaceBook/>
         <Instagram/>
         <LinkedIn/>
      </>
   )
}

export default Home